import { Toast } from "@deere/fuel-react";
import { Box } from "@mui/material";
import React from "react";
function ToastUtility({
  topOffset,
  toastDisplay,
  toastVariant,
  handleClose,
  toastMessage,
}) {
  function addLineBreaks(text) {
    if (text)
      return text.split("\n").map((line, index) => (
        <React.Fragment key={index}>
          {line}
          {index < text.length - 1 && <br />}
        </React.Fragment>
      ));
    return text;
  }

  return (
    <Box
      maxWidth="30rem"
      marginX="auto"
      style={{
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 100,
        right: "10%",
        top: `${topOffset ? topOffset : "15%"}`,
        position: "fixed",
        display: toastDisplay,
      }}
    >
      <Toast variant={toastVariant} onClose={handleClose}>
        {addLineBreaks(toastMessage)}
      </Toast>
    </Box>
  );
}

export default ToastUtility;
